export default __webpack_public_path__ + "static/media/RUB.95dedc83.svg";